
import { Building, User } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ClaimRequest } from './ClaimRequestInterface';

interface ProcessedClaimRequestCardProps {
  request: ClaimRequest;
}

const ProcessedClaimRequestCard = ({ request }: ProcessedClaimRequestCardProps) => {
  return (
    <Card key={request.id} className="overflow-hidden">
      <CardHeader className="bg-gray-50 pb-3">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <Building className="w-4 h-4 text-gray-500" />
            <CardTitle className="text-lg">{request.company_name}</CardTitle>
          </div>
          <Badge className={request.status === 'approved' ? "bg-green-500" : "bg-red-500"}>
            {request.status === 'approved' ? 'Approved' : 'Rejected'}
          </Badge>
        </div>
        <CardDescription>
          Requested on {new Date(request.created_at).toLocaleDateString()}
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-4">
        <div className="space-y-3">
          <div className="flex items-center space-x-2">
            <User className="w-4 h-4 text-gray-500" />
            <div className="text-sm">
              <p className="font-medium">{request.full_name}</p>
              <p className="text-redflags-gray">{request.job_title}</p>
            </div>
          </div>
          <p className="text-sm text-redflags-gray">{request.email}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProcessedClaimRequestCard;
